import listing from "./listing";
export function findListing(key) {
  for (let i = 0; i < listing.length; i++) {
    const l = listing[i];
    if (l.key === key) return l;
  }
  console.error(`Error finding listing with key ${key}`);
}
